module.exports = __webpack_public_path__ + "img/carousel-fullscreen.216c1aea.png";